// 销售统计数据
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 当前所属集团
Mock.mock(/sale_report\/current/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'group_id': 123456,
    'group_name': '深圳ABC4S集团',
    'shop_id': 123456,
    'shop_name': '深圳ABC4Sd',
    'time': '2017-11-08'
  },
  'message': 'ok'
})

// 销售展厅指标统计
Mock.mock(/sale_report\/store_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data|2': [{
    'arrived': 5,
    'deal': 11,
    'review': 11,
    'store_name': '门店A',
    'store_id': 12
  }]
})

// 潜客到店成交指标统计
Mock.mock(/sale_report\/cule_arrived_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data|2': [{
    'arrived': 5,
    'deal': 15,
    'review': 15,
    'store_name': '门店B',
    'store_id': 13
  }]
})

// 潜客意向车型转成交统计
Mock.mock(/sale_report\/car_series_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': {
        'count': 123,
        'rate': 0.01
      },
      'clue': {
        'count': 123,
        'rate': 0.01
      },
      'clue_to_deal_rate': 0.11,
      'deal': {
        'count': 345,
        'rate': 0.02
      },
      'car_series': 'CT'
    },
    {
      'arrived': {
        'count': 123,
        'rate': 0.01
      },
      'clue': {
        'count': 123,
        'rate': 0.01
      },
      'clue_to_deal_rate': 0.11,
      'deal': {
        'count': 345,
        'rate': 0.02
      },
      'car_series': 'ES'
    }
  ],
  'message': 'ok'
})

// 线索转订单成交统计
Mock.mock(/sale_report\/dcc_clue_to_deal_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': 123,
      'arrived_rate': 0.11,
      'channel': '400来电',
      'clue': 123,
      'deal_rate': 0.11
    },
    {
      'arrived': 123,
      'arrived_rate': 0.11,
      'channel': '网络渠道',
      'clue': 123,
      'deal_rate': 0.11
    }
  ],
  'message': 'ok'
})

// 客户区域分布转成交统计
Mock.mock(/sale_report\/dcc_area_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data|2': [
    {
      'arrived': {
        'count': 123,
        'rate': 0.01
      },
      'clue': {
        'count': 345,
        'rate': 0.05
      },
      'clue_to_deal_rate': 0.22,
      'deal': {
        'count': 123,
        'rate': 0.01
      },
      'area': '宝安区'
    }
  ],
  'message': 'ok'
})

// 客户信息渠道转成交统计
Mock.mock(/sale_report\/channel_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data|2': [
    {
      'arrived': {
        'count': 123,
        'rate': 0.01
      },
      'clue': {
        'count': 123,
        'rate': 0.01
      },
      'clue_to_deal_rate': 0.11,
      'deal': {
        'count': 123,
        'rate': 0.01
      },
      'channel_source': '网络渠道'
    }
  ],
  'message': 'ok'
})

// 所有店铺
Mock.mock(/sale_report\/stores/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'id': 123,
      'name': '深圳中升雷克萨斯4S店'
    },
    {
      'id': 456,
      'name': '深圳中升奔驰4S店'
    }
  ],
  'message': 'ok'
})

// 到店转成交漏斗分析
Mock.mock(/sale_report\/arrived_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': 5,
      'deal': 11,
      'review': 11,
      'store_name': '深圳ABC4S'
    }
  ],
  'message': 'ok'
})
